import { render, staticRenderFns } from "./UpdateIdCard.vue?vue&type=template&id=41b1985c&scoped=true&"
import script from "./UpdateIdCard.vue?vue&type=script&lang=js&"
export * from "./UpdateIdCard.vue?vue&type=script&lang=js&"
import style0 from "./UpdateIdCard.vue?vue&type=style&index=0&id=41b1985c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b1985c",
  null
  
)

export default component.exports